import { Component } from 'vue-property-decorator';
import { Button, TextInput, Selector } from 'streamlabs-beaker';
import EditorBase from '../editor/EditorBase';
import { cloneDeep } from 'lodash-es';
import ProjectApi from '@/apis/project-api';
import { IProject, IScene } from '@/helpers/editor';
import HttpHelper from '@/helpers/http';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import { EModalName } from '@/helpers/modal';
import Tooltip from '@/components/utils/Tooltip.vue';
import NotificationHelper from '@/helpers/notification';
import { EAnalyticsEvent } from '@/helpers/analytic';
import { EUserAdEvent } from '@/helpers/user';
import UtilHelper from '@/helpers/utils';

@Component({
  components: {
    SButton: Button,
    STextInput: TextInput,
    SSelector: Selector,
    ConfirmationModal,
    Tooltip,
  },
})
export default class ProjectContainerMixin extends EditorBase {
  projectName: string = null;
  resolution: string = '720p - 30FPS';

  get INPUT_WIDTH(): string {
    return '232px';
  }

  get resolutionOptions(): string[] {
    return this.allowedStreamResolutions.map(resolution => resolution.label);
  }

  get hasProject(): boolean {
    return !!this.projects?.length;
  }

  openCreateProjectModal() {
    this.$modal.show(EModalName.createEditProject);
  }

  async createEditProject() {
    const isEdit = !!this.projectToEdit;
    if (!this.projectName || this.projectName === '') {
      NotificationHelper.error('Please enter a name for the project.');
      return;
    }

    if (50 < this.projectName.length) {
      NotificationHelper.error('Maximum character length for project name 50');
      return;
    }
    const data = {
      title: this.projectName,
      settings: {
        resolution: this.allowedStreamResolutions.find(resolution => resolution.label === this.resolution).value,
        newlyAdded: true,
      },
    };

    let response = null;

    if (!isEdit) {
      response = await HttpHelper.post('/api/v1/users/projects', data);
    } else {
      response = await HttpHelper.post(`/api/v1/users/projects/${this.projectToEdit.uuid}`, data);
    }

    if (response.success) {
      let newProject: IProject = response.project;
      const projects = cloneDeep(this.projects);

      if (!isEdit) {
        projects.push(newProject);
        this.projects = projects;
        UtilHelper.trackGTMEvent({ event: EUserAdEvent.projectCreated });
        this.$sla.sendEvent(EAnalyticsEvent.projectCreated);
      } else {
        this.projects = projects.map((project) => project.id === newProject.id ? newProject : project);
      }

      this.resetValues();

      this.$modal.hide(EModalName.createEditProject);

      if (!isEdit) {
        const url = this.isMobile ?
          `/projects/${newProject.uuid}/scenes` :
          `/projects/${newProject.uuid}/scenes/${newProject.scenes[0].uuid}/editor`;
        this.selectedProject = newProject;
        this.$router.push(url);
      }
    }
  }

  resetValues() {
    this.projectName = null;
    this.resolution = '720p - 30FPS';
    this.projectToEdit = null;
  }
}
